import ProjectItemOne from "./ProjectOne";
import ProjectItemTwo from "./ProjectTwo";
import * as Project from "./projectStyles";
import ProjectItemSmall from "./ProjectSmall";

import { useWindowWidth } from "@react-hook/window-size";

export default function ProjectContainer() {
  const projectList = [
    {
      title: "CS EXPO",
      photoUrl: "/csexpo.png",
      description:
        "It is the website for the CS EXPO, which is the event by the graduating CS students of FEU Tech to showcase their theses that are aimed to improve the community.",
      technologies: ["AstroJS", "React", "Javascript", "HTML/CSS"],
      github: "https://github.com/Simperfy/CS-EXPO-2022",
      website: "https://feutech.acm.org/csexpo2022/",
    },
    {
      title: "Flickify",
      photoUrl: "/flickify.JPG",
      description:
        "A music information website inspired from netflix. It uses spotify API, and users can use their login credentials from spotify, to access their list of music and other related infos. Users can also search musics and albums they are interested with.",
      technologies: [
        "React",
        "Redux",
        "Context",
        "Hooks",
        "Spotify API",
        "SCSS",
      ],
      github: "https://github.com/DauntlessDev/flickify-react/",
      website: "https://flickify.netlify.app/",
    },
    {
      title: "Rioflix",
      photoUrl: "/rio.JPG",
      description:
        "A movie information website inspired from netflix, which includes list of movies, documentaries, series, etc. It is created with the best practices in react development while using the latest technologies. It also includes testing using jest.",
      technologies: [
        "React",
        "Context",
        "Hooks",
        "Firebase",
        "MUI",
        "SCSS",
        "Jest",
      ],
      github: "https://github.com/DauntlessDev/rio-react",
      website: "https://rioflix.netlify.app/",
    },
    {
      title: "Trade-Off",
      photoUrl: "/barter.JPG",
      description:
        "A barter system website where users can exchange goods without using money. It is made using php with CodeIgniter4 and MVC design pattern. This was made with collaboration with others, which really improve my communication & VC skills.",
      technologies: ["VanillaJS", "CodeIgniter", "PHP", "mySQL", "Heroku"],
      github: "https://github.com/DauntlessDev/Barter-system",
      // website: "https://barter-system.herokuapp.com/",
    },
  ];

  const windowWidth = useWindowWidth();

  return (
    <div id="projects">
      <Project.HeaderContainer data-aos="fade-up">
        <Project.HeaderNumber>02.</Project.HeaderNumber>
        <Project.HeaderTitle>Projects that i've built</Project.HeaderTitle>
      </Project.HeaderContainer>
      <Project.Container>
        {projectList &&
          projectList.map((item, index) =>
            windowWidth <= 1000 ? (
              <ProjectItemSmall project={item} key={index} />
            ) : index === 0 ? (
              <ProjectItemOne project={item} key={index} />
            ) : index % 2 === 0 ? (
              <ProjectItemOne project={item} key={index} />
            ) : (
              <ProjectItemTwo project={item} key={index} />
            )
          )}
      </Project.Container>
    </div>
  );
}
